<div class="value" *ngFor="let val of value">{{val | date: 'dd.MM.yyyy HH:mm'}}</div>
<div class="value" *ngIf="!value?.length">-</div>
